import {Pipe, PipeTransform} from '@angular/core';
import filesize from 'filesize';

@Pipe({
    name: 'filesize',
    standalone: false,
})
export class FileSizePipe implements PipeTransform {
    transform(value: number | string | null | undefined, options?: object): string {
        if (value == null) return '';
        return filesize(Number(value), options ?? {}) as string;
    }
}
